module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("2: Cometh the Hour, Cometh the Men")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The sudden uptick in interest in mining as a weapon of war, due to its success in the Russo-Japanese War, led to a concomitant curiosity regarding minesweeping, for which no ready solution had seemed apparent from the experience in the conflict. And the growing realisation that submarines were not just ‘toys’ but a clear and present danger to the battlefleet (and to trade) kindled the desire for patrol vessels – hardy, versatile enough to sweep for mines and seek out underwater threats, capable of surviving in the stormy conditions of the North Sea and readily available in time of war. The Royal Navy had spent several fortunes on warships; but these were battleships, destroyers to protect them, cruisers to seek out the enemy. No one had thought it fit to invest in patrol vessels to the extent that now seemed necessary, especially at a time of budget scrutiny when early twentieth-century Liberal governments sought to increase expenditure on social causes, such as old age pensions. Some senior officers began to think through the problem, especially with regard to mines.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p021_01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("2. Admiral Lord Charles Beresford. (photo; Library of Congress)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("History has not been kind to Admiral Lord Charles William de la Poer Beresford, First Baron Beresford of Metemmeh and Curraghmore (plate 2), and with some justification. Self-important and vain, he was a member of parliament, vitriolic enemy of Fisher, and the man of whom it was said ‘in the navy we knew he was not a sailor, but thought he was a politician; in the House of Commons they knew he was not a politician but thought he was a sailor’."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn1",
      "id": "ch2fn1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, it was to Beresford that the navy owed the insight that fishing trawlers might be the answer to the problem of minesweeping (and by extension, general patrol work).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While in command of the Mediterranean Fleet during 1905, Beresford had instigated experiments in minesweeping using his ships’ small boats. In 1907, he was appointed to command the Channel Fleet, and proceeded to take it on a grand tour of the British Isles, primarily intended to boost his own popularity and provide more publicity for his war with Fisher. As one lieutenant in the fleet noted, the cruises were ‘principally a processional career around the ports of Britain … I do not recall that any serious problems of war were either attempted or solved [but] Lord Charles received deputations, addressed crowded meetings in his honour, and became freeman of innumerable cities.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn2",
      "id": "ch2fn2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 27 June 1907, Beresford’s peregrinations brought him to Grimsby. In company, the admiral had his flagship, the pre-dreadnought battleship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("King Edward VII;")]), _vm._v(" five more battleships, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Britannia, Dominion, Hindustan, Illustrious")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Swiftsure;")]), _vm._v(" the cruisers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gladiator, Sentinel")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Talbot;")]), _vm._v(" and the torpedo boats "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Avon, Coquette, Blackwater, Cynthia, Flirt, Gala, Gypsy, Kangaroo, Lee, Leopard, Osprey")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Waveney")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here, the mayor visited the flagship, and festivities and a civic luncheon were held ashore for the visiting sailors; in return Beresford inspected a number of trawlers and held talks with their skippers. Most importantly, he held discussions with Councillor George Alward, a prominent trawler owner, and an author and authority on fishing matters. Alward had been a prime mover in the development of the steam trawler and the steam winches that were used in managing their nets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between them, they agreed that there were similarities between the technical needs of minesweeping as now perceived and the work of trawlermen in working their nets, cables and other tackle. As Beresford himself put it, ‘our fishing fleet will be rendered inactive in time of war, and will in consequence be available for war service. Fishermen, by virtue of their calling, are adept in the handling and towing of wires and trawls, more so than naval ratings.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn3",
      "id": "ch2fn3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From these comparisons, it was but a short step to consider the utility of the strong, sturdy, steam trawler in minesweeping operations. Beresford pressed the Admiralty to undertake a trial of the idea and in early 1908 his fleet navigator, Commander Edward L Booty, was despatched from the flagship to Grimsby to collect two suitable vessels and return with them to Portland, where the North Sea trawlers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andes")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Algoma")]), _vm._v(", built in 1899 and belonging to Alward himself, arrived on 5 February, complete with their skippers and crews of nine men to each boat.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p022_01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("3. Built in Goole in 1908, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seaflower")]), _vm._v(" was one of the six trawlers delivered to the Admiralty in 1909 for evaluation as minesweepers and later became a training ship for the "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNR")]), _vm._v("("), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("T")]), _vm._v("), based at Chatham and Sheerness. At the outbreak of war, she was allocated as a minesweeper.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("(© National Maritime Museum N04404)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beresford had formed a Channel Fleet Mining Committee to oversee the testing, headed by his Chief of Staff, Captain Frederick C Doveton Sturdee, and for eight days the little vessels, just over 100ft long, were put through their paces sweeping dummy mines. The first attempts proved less than satisfactory, but at the trawlermen’s suggestion the use of improved kites rather than the original net otter boards gave every promise of success. Indeed ‘the trawlers found that they could spread the sweep over two cables maintaining a sea-going sweeping speed of 5–6 knots according to weather’."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn4",
      "id": "ch2fn4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])]), _vm._v(" This was in fact never improved on during the war, as the additional weight of more wires impeded speed and efficiency. Six further trawlers were ordered ‘off the stocks’ by the Admiralty for continued research and development, to be conducted under Captain Clement Greatorix; and the official report into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andes")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Algoma")]), _vm._v(" experiments noted that ‘the results achieved were considered sufficiently satisfactory to call for tactical considerations of the value of minesweepers in general and estimates of the personnel and materiel requisite to form an adequate force’."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn5",
      "id": "ch2fn5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])]), _vm._v(" This was later calculated at 100 trawlers and 1,000 skippers and ratings to man them. It would prove to be a considerable underestimate."), _c('a', {
    attrs: {
      "href": "#/xhtml/#star_7",
      "id": "star-7"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first four of the six Admiralty trawlers were received in April 1909; they were billed as necessary for ‘subsidiary services’, their true intention being kept quiet. Named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seamew")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seaflower")]), _vm._v(" (plate 3), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spider")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sparrow")]), _vm._v(" (the other two were christened "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rose")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Driver")]), _vm._v(") all but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spider")]), _vm._v(" would survive the coming war"), _c('a', {
    attrs: {
      "href": "#/xhtml/#star_8n",
      "id": "star-8n"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("†")])]), _vm._v(" They proved that such vessels had the advantage of being able to function in heavier weather than, say, a destroyer and with their fish holds full of coal they were able to stay at sea for three to four weeks at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, in July 1914, the Admiralty owned only sixteen trawlers, including the original six purchased from Alward. These were still used for minesweeping training and the remainder were employed towing targets. There were also two survey vessels, converted from trawlers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daisy")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esther")]), _vm._v(", both built in 1911. They were additionally fitted as minesweepers.")]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Royal Naval Reserve – Trawler Section")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Having identified the type of ship which would serve their purpose, the Admiralty had to face the question of how to obtain and man them.")]), _vm._v(" "), _c('h4', {
    staticClass: "head"
  }, [_vm._v("Manpower")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Royal Naval Reserve ("), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNR")]), _vm._v(") was created by the Naval Reserve Act of 1859, itself a product of the invasion scare of the same year. For one month a year, merchant sailors and fishermen were given gunnery training on drill ships stationed around the coast. When war was declared they were liable to be drafted to the fleet or reserve ships. As first created, the "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNR")]), _vm._v(" consisted of up to 30,000 merchant seamen and fisherman who the navy could call on in times of crisis. By 1914, membership was drawn from professional officers and ratings of the Mercantile Marine, the fishing fleet and ex-naval ratings. For the former, it was voluntary but many major steamer companies encouraged their employees to join. After basic training, further periodic training with the fleet was undertaken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1910, it was decided to expand the naval reserve through the creation of a special reserve for fishermen, the Royal Naval Reserve – Trawler Section. The first skipper to join the "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNT(T)")]), _vm._v(" signed on in Aberdeen on 3 February 1911 (his name was Peter Yorston) and approval was given to recruit 1,278 men to crew 142 trawlers."), _c('a', {
    attrs: {
      "href": "#/xhtml/#star_7j",
      "id": "star-7j"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("*")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn6",
      "id": "ch2fn6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])]), _vm._v(" By April 1912, forty-two were ready but Commander Plunkett noted that ‘in war we shall have 140 trawlers available [for minesweeping]’."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn7",
      "id": "ch2fn7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trawlers taken up by the Admiralty in time of need usually came complete with their pre-existing crews. Skippers were given warrant officer rank. Crewmen signed on under a T-124 agreement (see appendix 2) whereby they consented to serve under Admiralty rules (specifically it bound them to the Naval Discipline Act) in any commissioned vessel but retained certain aspects of their civilian pay and benefits. The ship’s complement was supplemented by the addition of a signals rating and/or W/T operator and sometimes a regular navy sub lieutenant or other officer. And by the end of 1910, permission had been given to employ petty officers from the Royal Fleet Reserve ("), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RFR")]), _vm._v(")"), _c('a', {
    attrs: {
      "href": "#/xhtml/#star_9",
      "id": "star-9"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("†")])]), _vm._v(" in trawlers; they were intended to act as third in command and offer advice on ‘proper’ naval signalling, record keeping and other procedures. Additionally, annual courses for officers on the retired and emergency lists, provisionally assigned to unit-command of minesweepers, had begun. ‘Certain retired lieutenants do a mining course yearly and are ready to take charge, one lieutenant to six trawlers’, confided Reginald Drax."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn8",
      "id": "ch2fn8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially, skippers received £3.6s for their four days’ training and a retainer of £10 per annum. Second hands and engineers were paid £2.4s for four days’ training and a retaining fee of £8. Deck hands were given £1.6s and an annual fee of £5 and coal trimmers received the same training rate but only £4 per annum."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn9",
      "id": "ch2fn9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When war came, there was an enthusiastic response to the call for fishermen volunteers, at least if the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fraserburgh Times")]), _vm._v(" is to be believed. In its edition of 4 August, the newspaper noted that:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("the calling out of the Royal Naval Reserve"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star_11",
      "id": "star-11"
    }
  }, [_vm._v("§")])]), _vm._v(" created great excitement in Fraserburgh, where hundreds of Highland hired men, engaged meantime on the herring fishing boats, are members of the Reserve. During Sunday forenoon, 257 men presented themselves at the Custom House, and received their warrants. In the afternoon at 1530 a special train, carrying 233 reservists, left Fraserburgh for Portsmouth. Unparalleled scenes were witnessed at the railway station, where several thousand assembled to give the men a hearty send-off. They marched from the Custom House to the station, headed by the Fraserburgh pipe band, under the charge of Leading Seamen Alexander Sim and Noah Killoh, both of Fraserburgh. For fully half a mile along the railway thousands of spectators lined the embankments on both sides, and tumultuous cheers were raised."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn10",
      "id": "ch2fn10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once at war, further financial incentive was provided. Wages were based on normal expectations for the fishing trade less 20 per cent; but a sum of £200 was offered to any trawler or auxiliary vessel which sank or captured a U-boat. This was raised to £1,000 in January 1915; at the same time £200 was awarded for damaging a U-boat and a bounty of £5 offered for each mine destroyed."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn11",
      "id": "ch2fn11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])]), _vm._v(" Salvage and prize money were sources of additional income for trawler crew. Over 400 trawlers received such payments during the course of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially, there was no uniform provided; but concerns grew that men captured in such a state of undress in time of war would be executed as pirates. It was agreed that a badge would be produced which identified the fishermen as part of the Royal Navy. This comprised the letters ‘RNR’ above the letter ‘T’ embroidered in red or gold onto a dark blue rectangle all surmounted by a gold and red crown."), _c('a', {
    attrs: {
      "href": "#/xhtml/#star_12",
      "id": "star-12"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("ß")])]), _vm._v(" And for skippers, as Lieutenant Maitland Walter Sabine Boucher, navigating officer of the Lowestoft trawler depot ship and torpedo gunboat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halcyon")]), _vm._v(" noted, ‘enough officers’ uniforms could not be produced at short notice for so many skippers. Each therefore was given an officers’ cap and a set of uniform buttons, which he was told to sew onto his best suit.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn12",
      "id": "ch2fn12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("Throughout the war, recruitment into the "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNR")]), _vm._v("("), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("T")]), _vm._v(") continued. By the Armistice, the strength was 39,000 skippers and ratings, about a quarter of whom were employed on minesweeping duties. ‘The institution of the Trawler Reserve’, wrote the author of an official post-war report, ‘will always rank as a monumental achievement in naval administration and the scheme devised three years before the war stood the test of rapid expansion to a degree far beyond expectation at the time of its inception.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn13",
      "id": "ch2fn13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('h4', {
    staticClass: "head"
  }, [_vm._v("Ships")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So, men could be had; but what about vessels for them to crew? Captain Bernard Currey "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RN")]), _vm._v(" suggested that a contract between the Admiralty and fishing boat owners be drawn up that would allow the navy to take up sufficient vessels as necessary during a conflict. With First Sea Lord Jacky Fisher’s approval, the Admiralty entered into negotiations with the Board of Agriculture (Fisheries Department), the local Fisheries Boards and trawler owners to agree terms for the hire of their vessels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those owners who accepted the terms offered had their vessels entered on a ‘specialist list’ which rendered them subject to release on request by the Admiralty. Lease terms were based on the boat’s tonnage. The hull and outfit were valued at £18 for each unit of gross tonnage and at £40 per each unit of nominal horsepower. The value so calculated was depreciated for every full year of the trawler’s age. The hire then paid was 12 per cent of this annual valuation. The Admiralty had the right of inspection at any time and the owners could withdraw vessels from the list, subject to notification of the authorities. Vessels needed to be less than ten years old and able to steam 1,000 miles at 8 knots. One hundred and forty-six trawlers were covered by these agreements when war came.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mobilisation Officers were appointed for each key port in November 1911. When mobilisation occurred, this officer was to receive a telegram informing him which vessels were to be taken up and had then to work with the port Registrar of Shipping and Seamen to prepare crews to man the trawlers. The Mobilisation Officer had also to provide each skipper with the requisite charts and sailing orders. On arrival at his destination, the skipper was to draw naval stores, a White Ensign, paint his vessel grey and obliterate his registry port number. In reality, when the time came some of these activities were obeyed only in the breach; and indeed, within the first month of the war Admiral John Jellicoe, CinC Grand Fleet, ordered that all his patrol trawlers should retain their civilian livery and markings in order to persuade the enemy that they were unarmed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For war purposes, trawlers would be formed into groups of six, each unit to be placed under the command of a (previously trained, see above) "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RN")]), _vm._v(" or "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNR")]), _vm._v(" officer, the latter holding a master’s or mate’s ‘Foreign-Going Certificate’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the call up of trawlers was not a simple process, for demand soon exceeded supply. On 9 November 1914, the First Sea Lord, Jacky Fisher, recalled to the position on 30 October, instructed the CinC Home Fleets that he should ‘arrange to take up as many trawlers as you require from the Scotch fishing ports, the local SNOs undertaking this’. The reason given was that ‘it is very difficult to obtain more trawlers and man them in the southern ports and the men aren’t so well suited to the local conditions as in the north’."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn14",
      "id": "ch2fn14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])]), _vm._v(" And by September 1916 only 500 trawlers remained in private hands, with over 1,300 being taken up by that stage in the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The navy’s first priority had been to secure hired vessels. But the need for these hardy fishing vessels had outstripped all possible calculation and by mid-1916 it seemed that all those trawlers suitable for naval work had been gathered up. As a partial remedy, the Admiralty built their own vessels, the so-called ‘Admiralty trawlers’. Between 18 August and 26 September, a series of conference and meetings with trawler operators resulted in a recommendation on 26 October for three classes of Admiralty trawler. By the end of the war 453 were commissioned, either purpose built, purchased from foreign sources or taken as prizes (see appendix 3).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The major fishing ports of Hull and Grimsby contributed heavily to the cause; from the two combined, 9,000 fishermen and 829 hired trawlers served."), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Sources#ch2rfn15",
      "id": "ch2fn15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])]), _vm._v(" Lowestoft and Aberdeen were also large contributors, with approximately 300 fishing vessels each.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The navy had not initially considered the mobilisation of drifters in their agreements with the fishing industry and owners. But the drifter proprietors proved anxious that the Admiralty should take the boats off their hands after they found themselves precluded by the needs of war from their most productive fishing grounds. It was perhaps just as well, for the humble herring drifter was to play a significant role in the Great War at sea as well. Some 1,372 were requisitioned during the conflict and additionally the Admiralty, as with trawlers, built their own to provide sufficient numbers, constructing 318 drifters, both wooden and steel (see appendix 4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Losses were significant and continuous throughout the conflict. The second and third Royal Navy vessels to be sunk in the war were both trawlers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thomas W Irvin")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crathie")]), _vm._v(". They went down on 27 August 1914, sweeping mines off the mouth of the River Tyne, laid the previous day by German cruisers. They had swept seven mines when, at 1625, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thomas W Irvin")]), _vm._v(" hit one and blew up, killing three crewmen. Forty minutes later, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crathie")]), _vm._v(" – which had already snagged two mines in her sweep wires – caught a third which went unseen and exploded under her. Two men lost their lives. All the dead were members of the "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNR")]), _vm._v("("), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("T")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The penultimate "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RN")]), _vm._v(" vessel to be sunk in the war was also a trawler, the former Grimsby-registered vessel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Renarro")]), _vm._v(". On 10 November 1918, one day before the war ended, she was minesweeping in the Dardanelles where she snagged three mines in her tackle. Her crew tried surging the wire and steering an ‘S’ manoeuvre to free them but as they were doing so, the mines detonated and she rapidly sank. All twelve of her crew died with her.")]), _vm._v(" "), _c('p', {
    staticClass: "border"
  }), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star-7",
      "id": "star_7"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("*")])]), _vm._v(" It is possible that the idea of using trawlers came about prior to Beresford’s epiphany and his subsequent claims to parenthood of the concept. Admiral George Ballard related after the war that the idea had come up in discussion at the Admiralty in 1906 and was submitted to First Sea Lord Sir John Fisher. He ordered that the next time the Home Fleet was cruising in the vicinity of Grimsby it should call in and inspect some trawlers and report on their suitability for minesweeping (Taffrail, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Swept Channels")]), _vm._v(", p40).")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star-8n",
      "id": "star_8n"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("†")])]), _vm._v(" She was wrecked off Lowestoft on 21 November 1914.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star-7j",
      "id": "star_7j"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("*")])]), _vm._v(" In fact, on mobilisation in August 1914 there were only sufficient crewmen available to man ninety-four trawlers.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star-9",
      "id": "star_9"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("†")])]), _vm._v(" Founded in 1905, initially to provide civilian-manned coaling ships for the fleet in home waters or abroad, it was a force drawn from former naval ratings and petty officers who, after completing their contractual service with the Royal Navy, were liable to recall in times of emergency. The liability lasted for a specified number of years after leaving active service in the navy.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star-11",
      "id": "star_11"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("§")])]), _vm._v(" The "), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RNR")]), _vm._v(" was activated at 0125 on 2 August 1914 after a meeting of the Army Council, chaired by Prime Minister Asquith.")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star-12",
      "id": "star_12"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("ß")])]), _vm._v(" For a second hand. There were many variations, such as the letters embroidered in red on a blue ground and no crown for crewmen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1841f62d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter02.vue
// module id = 90
// module chunks = 0